/**
 * Utility for managing workspace sort order preference
 * Stored in localStorage for persistence
 */

export type SortOrder = 'default' | 'folders-first' | 'files-first';

const SORT_ORDER_KEY = 'workspace_sort_order';

/**
 * Get the current sort order preference from localStorage
 */
export const getSortOrder = (): SortOrder => {
  try {
    const stored = localStorage.getItem(SORT_ORDER_KEY);
    if (
      stored &&
      ['default', 'folders-first', 'files-first'].includes(stored)
    ) {
      return stored as SortOrder;
    }
  } catch {
    // localStorage not available
  }
  return 'default';
};

/**
 * Set the sort order preference in localStorage
 */
export const setSortOrder = (order: SortOrder): void => {
  try {
    localStorage.setItem(SORT_ORDER_KEY, order);
  } catch {
    // localStorage not available
  }
};
